export default {
    auth: {
        getMe: "/api/user/auth/me?firestore_token=true",
    },
    chat: {
        sendMessage: process.env.MIX_API_FUNCTION_URL_SEND_MESSAGE_TO_WHATSAPP,
    },
    orders: {
        sendOrderDetailsMessage: "/api/main-order/payment/order-summary",
    },
};
